<template>
    <div class="change-qt-cotas d-flex align-center">
        <v-icon
                slot="prepend"
                color="white"
                size="14"
                :class="['cursor-pointer', 'change-qt-cotas__button', { 'change-qt-cotas__button--disabled': m_value <= 1 || !canRemove, 'change-qt-cotas__button--active': m_value > 1 && canRemove}]"
                @click="handleRemoveCota"
        >
            lnr-chevron-left
        </v-icon>

        <span class="qt-cotas font-weight-bold mx-4 ">{{ m_value | paddingLeftTwoCases }}</span>

        <v-tooltip color="white" bottom v-model="showTooltip" slot="append">
            <template v-slot:activator="{ on,attrs }">
                <v-icon
                        @mouseleave="showTooltip = false"
                        @mouseenter="(isMaxLimitReached || !canAdd) && (showTooltip = true)"
                        color="white"
                        size="14"
                        :class="['cursor-pointer', 'change-qt-cotas__button', { 'change-qt-cotas__button--disabled': isMaxLimitReached || !canAdd, 'change-qt-cotas__button--active': !isMaxLimitReached && canAdd }]"
                        @click="handleAddCota"
                >
                    lnr-chevron-right
                </v-icon>
            </template>
            <span style="color:var(--primary);font-weight: 600;">{{ limitMessage }}</span>
        </v-tooltip>
    </div>
</template>

<script>
  export default {
    name: 'Counter',
    props: {
      value: Number,
      canAdd: { type: Boolean, default: true },
      canRemove: { type: Boolean, default: true },
      maxValue: { type: Number, default: Infinity },
      limitMessage: { type: String, default: 'Limite alcançado' }
    },
    data: () => ({
      showTooltip: false
    }),
    computed: {
      m_value: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      },
      isMaxLimitReached () {
        return this.m_value >= this.maxValue
      }
    },
    watch: {
      isMaxLimitReached (val) {
        if (val) {
          this.$nextTick(() => {
            this.showTooltip = true
          })
        }
      }
    },
    methods: {
      handleRemoveCota () {
        if (this.canRemove && this.m_value > 1) {
          this.m_value--
        }
      },
      handleAddCota () {
        if (this.canAdd && !this.isMaxLimitReached) {
          this.m_value++
        }
      }
    }
  }

</script>

<style scoped>
.qt-cotas {
  font-size: 1.5rem;
  color: var(--primary);
  font-weight: 600;
}

.change-qt-cotas__button{
    border-radius: 50%;
    padding: 10px;
    font-weight: 700;
}

.change-qt-cotas__button--active{
    background-color: var(--primary);
    cursor: pointer;
}
.change-qt-cotas__button--disabled{
    background-color: var(--dark);
    cursor: default;
}
</style>
